import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent, IonLabel } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P0003605DureeQuotidienneInjection } from '../../../Enum/P0003605DureeQuotidienneInjection';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003605ConsigneRegulationRxEnum } from '../../../Enum/P0003605ConsigneRegulationRx';
import { P0003605HysteresisRegulationRx } from '../../../Enum/P0003605HysteresisRegulationRx';
import { P0003605EnSavoirPlusDosageComponent } from '../../EnSavoirPlus/p0003605-en-savoir-plus-dosage/p0003605-en-savoir-plus-dosage.component';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { P0003605EnSavoirPlusRegulationRXComponent } from '../../EnSavoirPlus/p0003605-en-savoir-plus-regulation-rx/p0003605-en-savoir-plus-regulation-rx.component';
import { P0003605ESPInstallationClComponent } from '../../EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';

@Component({
  selector: 'app-p0003605-injection-chlore-mise-en-oeuvre-desinfection',
  templateUrl:
    './p0003605-injection-chlore-mise-en-oeuvre-desinfection.component.html',
  styleUrls: [
    './p0003605-injection-chlore-mise-en-oeuvre-desinfection.component.scss',
  ],
  standalone: true,
  imports: [
    AffichageWarningComponent,
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    IonLabel,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    TranslatePipe,
    SwitchConfigurationComponent,
  ],
})
export class P0003605InjectionChloreMiseEnOeuvreDesinfectionComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.P0003605ESPInstallationCl = this.P0003605ESPInstallationCl.bind(this);
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  async P0003605ESPInstallationCl() {
    const modal = await this.slideModalController.create({
      component: P0003605ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P0003605DureeQuotidienneInjection =
    P0003605DureeQuotidienneInjection;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003605ConsigneRegulationRxEnum =
    P0003605ConsigneRegulationRxEnum;
  protected readonly P0003605HysteresisRegulationRx =
    P0003605HysteresisRegulationRx;
}
